import BooleanV1 from "../../../../components/form_builder/elements/boolean/BooleanV1.vue";

export default {
  componentName: "fb-boolean-v1",
  component: BooleanV1,
  defaultAttrs: {
    properties: {
      label: "",
      value: false,
      style: {},
      required: false,
      resetStoreValues: false,
      eFormEditable: true,
      hidden: false
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
